//import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Http } from '@angular/http';
import { ConfigProvider } from '../config/config';

export function createTranslateLoader(http: Http, config: ConfigProvider) {
  return new TranslateHttpLoader(http, 'https://paymonthlyboilershop.co.uk/'+'appLabels3?lang=',"");

}



// WEBPACK FOOTER //
// ./src/providers/translate/translate.ts